"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTruckOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30 17c0-5.09-4.3-7.75-4.48-7.86L25.28 9H22V6H2v19h3.14a4 4 0 007.72 0h4.28a4 4 0 007.72 0H30zm-5.3-6a8 8 0 013.22 5H22v-5zM9 26a2 2 0 112-2 2 2 0 01-2 2zm8.14-3h-4.28a4 4 0 00-7.72 0H4V8h16v12.14A4 4 0 0017.14 23zM21 26a2 2 0 112-2 2 2 0 01-2 2zm7-3h-3.14A4 4 0 0022 20.14V18h6z" })));
}
exports.default = SvgTruckOutline;
//# sourceMappingURL=TruckOutline.js.map